/**
 * Configuración de la landing.
 * Todo lo marcado con [[ ]] debe reemplazarse por datos reales antes de publicar.
 */

/** Link de pago. */
export const CHECKOUT_URL = 'https://master-plan-15.impultienda.ar/checkout'

/** Ancla de la sección de precio. */
export const PRICE_ANCHOR = '#precio'

export const PRICE = '19 USD'
export const REGULAR_PRICE = '67 USD'
export const TOTAL_VALUE = '227 USD'
export const BONUS_VALUE = '80 USD'
export const SAVINGS = '48 USD'

/**
 * Ventana del precio de lanzamiento, en horas.
 * El deadline es el próximo múltiplo exacto de esta ventana (hora de Argentina, UTC-3),
 * así que es el MISMO para todos los visitantes y nunca se reinicia por persona.
 */
export const COUNTDOWN_WINDOW_HOURS = 12

/** [[%]] — porcentaje real de cupos a precio de lanzamiento ya tomados. */
export const SPOTS_TAKEN_PERCENT = 0

/** Organizadoras usando el sistema. */
export const METRIC_BUYERS = '+700'

/** Valoración promedio. */
export const METRIC_RATING = '4.8'

/** Pixel de Meta. */
export const META_PIXEL_ID = '1860775818225031'
